// extracted by mini-css-extract-plugin
export default {"modalBackground":"BasicModal_modalBackground__f5dU5","buttonContainer":"BasicModal_buttonContainer__ANokt"};